<template>
  <WalletWorkPackageBody
    >
    <WaggonInfoBody
      color="white"
      :info_box="false"
      :wallet="true"
      >
      <template #body-content>
        {{$t('Project.Wallet.Card.Comments')}}
        <StandardFlexBox
          id="logList"
          direction="column"
          height="calc(50% - 30px)"
          :no_wrap="true"
          >
          <StandardDataField
            v-for="comment in comments"
            :key="comment.id"
            :header="`${comment.user} ${comment.created.substring(0, 19)}`"
            :value="comment.target === 'comment'?
                    comment.value:
                    `${comment.target} ${comment.action}: ${comment.value}`"
            icon="sms"
            :readonly="true"
            width="100%"
            />
            <StandardDataField
              style="position: sticky; position: -webkit-sticky; bottom: 4px"
              :key="update_key_add_comment"
              line_height="30px"
              color="grey darken-3"
              text_color="white"
              value=""
              icon="sms"
              append_icon="send"
              :placeholder="$t('Project.Wallet.Card.AddCommentPlaceholder')"
              width="100%"
              @changeValue="createLogListComment({
                project_id: project_id,
                train_id: step_card.train_id,
                taktarea_id: step_card.taktarea_id,
                twaggon_id: 0,
                twork_package_id: step_card.work_package_id,
                data: {
                  comment: $event,
                },
              }),
              update_key_add_comment++,
              scrollBottom('logList')
              "
              />
        </StandardFlexBox>
        {{$t('Project.Wallet.Card.Images')}}
        <StandardFlexBox
          id="images"
          direction="column"
          height="calc(50% - 30px)"
          :no_wrap="true"
          >
          <StandardDataField
            v-for="image in getUObjects({type: 'tworkpackageimages', ids: step.tworkpackageimages})"
            :key="image.id"
            :file_src="image.image"
            :file_type="image.type"
            :file_extension="image.extension"
            :header="`${image.user} ${image.created.substring(0, 19)}`"
            :value="image.comment"
            :readonly="true"
            width="100%"
            @clickImage="$router.push({
              name: 'TaktPlanWorkPackageImagesZoomImage',
              params: {
                image_id: image.id
              },
              })"
            />
            <!-- add image -->
          <StandardDataField
            style="position: sticky; position: -webkit-sticky; bottom: 4px"
            :key="update_key_add_image"
            line_height="30px"
            color="grey darken-3"
            text_color="white"
            :header="new_step_image.name"
            :value="new_step_image.comment"
            append_icon="send"
            :placeholder="$t('Project.Wallet.Card.AddImagePlaceholder')"
            width="100%"
            @changeValue="new_step_image.comment = $event"
            @clickAppendIcon="uploadStepImage()"
            >
            <template #prepend-slot>
              <v-icon
                v-if="!new_step_image.file"
                class="ml-1 mr-1"
                @click="$refs.addWorkpackageImage.click()"
                >
                attach_file
              </v-icon>
              <v-img
                class="standard-data-image-preview"
                v-else
                :src="new_step_image.local_url"
                height="34px"
                width="47px"
                contain
                @click="$refs.addWorkpackageImage.click()"
                />
              <input
                v-show="false"
                ref="addWorkpackageImage"
                type="file"
                capture="camera"
                @change="selectStepImage($refs.addWorkpackageImage.files[0])"
                >
            </template>
          </StandardDataField>
        </StandardFlexBox>
      </template>
    </WaggonInfoBody>
  </WalletWorkPackageBody>
</template>
<script>

  import { WalletMixin } from '@/mixins/Wallet.mixin.js'
  export default {
    props: ['project_id', 'step_card', 'step', 'comments', 'step_type'],
    mixins: [
      WalletMixin
    ],
    created() {
      setTimeout(function () {
        var element = document.getElementById("logList");
        element.scrollTop = element.scrollHeight;
      }, 200);
      setTimeout(function () {
        var element = document.getElementById("images");
        element.scrollTop = element.scrollHeight;
      }, 200);
    },
    methods: {
      scrollBottom(target) {
        setTimeout(function () {
          var element = document.getElementById(target);
          element.scrollTop = element.scrollHeight;
        }, 1000);
      },
      scrollBottomImages(target) {
        setTimeout(function () {
          var element = document.getElementById(target);
          element.scrollTop = element.scrollHeight;
        }, 2000);
      },
    }
  }
</script>
<style>
</style>
